function LockIcon() {
    return (
      <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 4.93029L3 4.99999L3 3.60529C3 0.131568 7 0.131573 7 3.60529C7 3.99125 7 5.31626 7 3.60529C7" stroke="black"/>
        <path d="M0.5 5C0.5 4.72386 0.723858 4.5 1 4.5H9C9.27614 4.5 9.5 4.72386 9.5 5V11C9.5 11.2761 9.27614 11.5 9 11.5H1C0.723858 11.5 0.5 11.2761 0.5 11V5Z" stroke="black"/>
        <ellipse cx="5.00033" cy="7.1999" rx="0.833333" ry="0.8" fill="black"/>
        <path d="M4.90355 6.77151C4.92952 6.67178 5.07113 6.67178 5.0971 6.77151L5.80105 9.4747C5.81755 9.53805 5.76974 9.5999 5.70428 9.5999H4.29637C4.23091 9.5999 4.1831 9.53805 4.1996 9.4747L4.90355 6.77151Z" fill="black"/>
      </svg>
    )
  }
  
  export default LockIcon;